module.exports = __webpack_public_path__ + "static/flags/TZ-ae0f561cbd5c6884efa0268ff1c69997.gif";